module.exports = __webpack_public_path__ + "media/media/product-card/vlsat-base-19ec88450a1ec2d554cca52df020d915.jpg";